import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Get, Post } from 'Xhr/Xhr';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { env } from 'env';

export const fetchSpeciality = async (
  GetSpeciality,
  selectedDepartment
) => {
  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_SPECIALITY_LIST_TURN}`,
    false,
    {
      idDarmangah: selectedDepartment.Id,
    }
  ).then((response) => {
    // console.log('fetchSpeciality=>', response);
    if (response.data.resCode === 1) {
      GetSpeciality(
        response.data.Data.List.map((element) => ({
          id: element.Id,
          label: ArabicToPersian(element.Name),
        }))
      );
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
